import React from 'react';

interface Props {
    children: React.ReactNode;
    dataTestId?: string;
}

const CallBadge = ({ children, dataTestId }: Props) => (
    <div
        data-test-id={dataTestId}
        className="bg-yellow flex size-6 items-center justify-center rounded-sm text-xs font-bold text-black dark:text-white"
    >
        {children}
    </div>
);

export default CallBadge;
